import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Tabs,
    Tab,
    Box,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton
} from '@material-ui/core';
import { AttachFile, Receipt, Delete } from '@material-ui/icons';

const QuotePageAttachmentsSection = ({
    activeTab,
    attachments,
    invoices,
    onTabChange,
    onUploadAttachment,
    onUploadInvoice,
    onDeleteAttachment,
    onDeleteInvoice,
    userRole = 'tecnico',
    classes = {},
    currentLanguage
}) => {
    if (userRole !== 'admin') return null;

    return (
        <Card className={classes.card} style={{ marginBottom: 24, padding: 16 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {currentLanguage.bepiService.workshop.workshop_quote_attachments_title}
                </Typography>

                <Tabs value={activeTab} onChange={onTabChange}>
                    <Tab label={currentLanguage.bepiService.workshop.workshop_quote_attachments_tab} />
                    <Tab label={currentLanguage.bepiService.workshop.workshop_quote_invoices_tab} />
                </Tabs>

                <Box style={{ marginTop: 16 }}>
                    {activeTab === 0 && (
                        <Box>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<AttachFile />}
                                onClick={onUploadAttachment}
                                style={{ marginBottom: 16 }}
                            >
                                {currentLanguage.bepiService.workshop.workshop_quote_add_attachment_btn}
                            </Button>
                            <List style={{ maxHeight: 200, overflow: 'auto' }}>
                                {attachments.map(anexo => (
                                    <ListItem key={anexo.id}>
                                        <ListItemText primary={anexo.nome} />
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                edge="end"
                                                onClick={() => onDeleteAttachment(anexo.id)}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}

                    {activeTab === 1 && (
                        <Box>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<Receipt />}
                                onClick={onUploadInvoice}
                                style={{ marginBottom: 16 }}
                            >
                                {currentLanguage.bepiService.workshop.workshop_quote_add_invoice_btn}
                            </Button>
                            <List style={{ maxHeight: 200, overflow: 'auto' }}>
                                {invoices.map(nota => (
                                    <ListItem key={nota.id}>
                                        <ListItemText primary={nota.numero} />
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                edge="end"
                                                onClick={() => onDeleteInvoice(nota.id)}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default QuotePageAttachmentsSection;
